export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11546.71f1d3e1.jpg";